export function getBrowserName() {
  let browserName = 'Unknown'
  if (typeof navigator === 'undefined') return browserName
  const { userAgent } = navigator

  if (userAgent.includes('Firefox')) {
    browserName = 'Firefox'
  }
  if (userAgent.includes('Safari')) {
    browserName = 'Safari'
  }
  if (userAgent.includes('Chrome')) {
    browserName = 'Chrome'
  }
  if (userAgent.includes('Opera') || userAgent.includes('OPR')) {
    browserName = 'Opera'
  }
  if ((navigator as any).brave) {
    browserName = 'Brave'
  }
  if (userAgent.includes('Ddg')) {
    browserName = 'DuckDuckGo'
  }
  if (userAgent.includes('Vivaldi')) {
    browserName = 'Vivaldi'
  }
  if (userAgent.includes('MSIE')) {
    browserName = 'Internet Explorer'
  }
  if (userAgent.includes('Edg')) {
    browserName = 'Edge'
  }
  return browserName
}

export function getOs() {
  if (typeof navigator === 'undefined') return 'Unknown'
  const { userAgent } = navigator

  // iPadOS 13+ (and Safari's "Request Desktop Site") reports a Macintosh user agent,
  // so touch support is the only way to tell an iPad apart from a Mac
  const isTouchMac = userAgent.includes('Mac') && (navigator.maxTouchPoints ?? 0) > 1

  if (userAgent.includes('iPhone') || userAgent.includes('iPad') || userAgent.includes('iPod') || isTouchMac) {
    return 'iOS'
  }
  // Windows Phone user agents contain "Android" too, so Windows is checked first
  if (userAgent.includes('Windows')) {
    return 'Windows'
  }
  // Android must be checked before Linux, because Android user agents contain both
  if (userAgent.includes('Android')) {
    return 'Android'
  }
  if (userAgent.includes('Mac')) {
    return 'MacOS'
  }
  if (userAgent.includes('Linux') || userAgent.includes('X11')) {
    return 'Linux'
  }
  return 'Unknown'
}

export function getModKey() {
  if (typeof navigator === 'undefined') return ''
  const os = getOs()
  if (os === 'MacOS' || os === 'iOS') {
    return '⌘'
  }
  return 'Ctrl'
}
